module.exports = __webpack_public_path__ + "static/media/withTick.9dcd6a6a.svg";